import React from "react";
import styled from "styled-components";
import {settingsActions} from "_actions";
import AvatarLoader from "./AvatarLoader";
import {useStateSelector} from "../../../../global/utils/stateUtils";

const AvatarWrapper = styled.div`
  margin-right: 9px;
  margin-top: 4px;

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
    margin-right: 10px;
    margin-top: 2px;
    margin-left: -5px
  }

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    margin-top: 16px;
    margin-right: 19px;
  }
`;
const StyledAvatar = styled.img`
  width: 45px;

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
    width: 50px;
    margin-top: 7px;
  }

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    width: 130px;
  }
`;

const load = () => ({
  load: settingsActions.avatarLoaded,
});

export default function Avatar() {
  const {
    settings: {
      avatar,
      avatarLoaded: loaded
    }
  } = useStateSelector();

  return (
    <AvatarWrapper className="AvatarWrapper">
      {
        avatar
          ?
          <StyledAvatar
            className="StyledAvatar"
            onLoad={() => !loaded && load()}
            src={avatar}
            alt="message-bot-icon"
          />
          : <AvatarLoader className="AvatarLoader"/>
      }
    </AvatarWrapper>
  );
}
